// Existing employees are matched only within the selected company.
export function planEmployeeImport(list, roster) {
  const key = value => String(value || '').trim().toLowerCase();
  const seenCodes = new Set();
  const seenPans = new Set();
  return list.map(employee => {
    const code = key(employee.employee_code);
    const pan = key(employee.pan);
    if (seenCodes.has(code) || (pan && seenPans.has(pan))) throw new Error('Duplicate Employee ID or PAN within the Excel file.');
    seenCodes.add(code);
    if (pan) seenPans.add(pan);
    const matches = roster.filter(existing => key(existing.employee_code) === code);
    if (matches.length > 1) throw new Error(`Employee ID ${employee.employee_code} has multiple records. Resolve these before uploading.`);
    const existing = matches[0];
    if (existing && existing.is_active === false) throw new Error(`Employee ID ${employee.employee_code} already exists and is inactive or previously relieved. Open their existing record to review; duplicate import blocked.`);
    if (existing && (!pan || key(existing.pan) !== pan)) throw new Error(`PAN does not match Employee ID ${employee.employee_code}. Salary update blocked.`);
    return { employee, existing };
  });
}

export function employeeSalaryPatch(employee) {
  const patch = { basic_salary: Math.round(Number(employee.basic)) };
  for (const field of ['vpf_pct', 'tds_amount', 'custom_basic_pct', 'custom_hra_pct', 'custom_special_allowance']) {
    if (employee[field] !== '' && employee[field] != null) patch[field] = Math.round(Number(employee[field]));
  }
  return patch;
}
